import { render, staticRenderFns } from "./BlockUser.vue?vue&type=template&id=0fe33850"
import script from "./BlockUser.vue?vue&type=script&lang=js"
export * from "./BlockUser.vue?vue&type=script&lang=js"
import style0 from "vue-multiselect/dist/vue-multiselect.min.css?vue&type=style&index=0&prod&lang=css&external"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports